/* eslint-disable react/jsx-no-duplicate-props */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { connect } from 'react-redux';
import { actions } from 'modules/admin';
import { actions as userActions } from 'modules/user';

export class RefundOrder extends Component {
  handleClickRefund = (id, firstName) => {
    const orderDetails = `Order number: ${id} for ${firstName}`;
    const refundConfirmed = window.prompt(`To confirm, please type 'refund' to refund ${orderDetails}`);
    if (refundConfirmed === 'refund') {
      this.props.refundOrder(id);
    }
  }

  handleClickResendReceipt = (id) => {
    if (this.props.order.receiptSent) {
      const resendReceiptAgain = window.confirm('Are you sure you want to resend receipt again?');
      if (resendReceiptAgain) {
        this.props.resendReceipt(id);
      }
    } else {
      this.props.resendReceipt(id);
    }
  }

  render() {
    const {
      createdAt,
      gift,
      id,
      User: {
        email,
        firstName,
        lastName
      },
      Offer: {
        name
      },
      OrderProducts,
      OrderTransactions,
      receiptSent,
      refunded,
      total
    } = this.props.order;

    let backgroundColor;
    const { resultNum } = this.props;

    if (resultNum % 2 !== 0) {
      backgroundColor = '#f4fbf3';
    }

    if (refunded) {
      backgroundColor = '#ffcc80';
    }

    let noRefundText;
    const refundsAllowed = (!gift && OrderTransactions[0].gateway !== 'manual');
    if (!refundsAllowed) {
      noRefundText = 'No refunds for gifts or free orders';
    } else {
      //already refunded or null
      noRefundText = refunded;
    }

    const products = OrderProducts.filter(product => !product.UpSellId && !product.BumpOfferId);
    const upsells = OrderProducts.filter(product => !!product.UpSellId);
    const bumpOffers = OrderProducts.filter(product => !!product.BumpOfferId);

    return (
      <Grid item xs={12} style={{ backgroundColor, paddingTop: '16px', paddingLeft: '16px', paddingBottom: '16px' }}>
        <Grid container spacing={0}>
          <Grid item xs={9}>
            <Grid container direction="row" spacing={0}>
              <Grid item xs={1}>
                <Typography>{resultNum}</Typography>
              </Grid>
              <Grid item xs={11}>
                <Grid container direction="column" spacing={0}>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Date:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{createdAt.slice(0, 10)}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Order ID:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{id}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>First name:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{firstName}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Last name:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{lastName}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Email:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography style={{ wordWrap: 'break-word' }}>{email}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Offer:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{name}</Typography>
                    </Grid>
                  </Grid>

                  {bumpOffers.length ?
                    <Grid container spacing={0}>
                      <Grid item xs={4}>
                        <Typography>Bump Offer IDs:</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        { bumpOffers.map((bumpOffer, i) => {
                          const hackyIndex = i + 100;
                          return (
                            <Typography key={hackyIndex} style={{ paddingRight: '16px', display: 'inline-block' }}>{bumpOffer.id}</Typography>
                          );
                        })}
                      </Grid>
                    </Grid> : null
                  }

                  {upsells.length ?
                    <Grid container spacing={0}>
                      <Grid item xs={4}>
                        <Typography>Upsell IDs:</Typography>
                      </Grid>
                      <Grid item xs={8}>
                        { upsells.map((upsell, i) => {
                          const hackyIndex2 = i + 100;
                          return (
                            <Typography key={hackyIndex2} style={{ paddingRight: '16px', display: 'inline-block' }}>{upsell.id}</Typography>
                          );
                        })}
                      </Grid>
                    </Grid> : null
                  }

                  <Grid container spacing={0}>
                    <Grid item xs={4}>
                      <Typography>Order total:</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>{`${total}`}</Typography>
                    </Grid>
                  </Grid>

                  { products.map((product, i) => {
                    return (
                      <Grid key={i} container spacing={0}>
                        <Grid item xs={4}>
                          <Typography>Product: </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography>{product.Product.name}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid container justify="flex-end" spacing={0} direction="row">
              <Grid item xs={12}>
                { !refunded && refundsAllowed ?
                  <Button
                    onClick={() => this.handleClickRefund(id, firstName)}
                  >Click to refund
                  </Button> :
                  <Typography style={{ paddingRight: '16px' }}>Refunded Status: { noRefundText }</Typography>
                }
              </Grid>
              <Grid item xs={12}>
                <Button
                  onClick={() => this.handleClickResendReceipt(id)}
                >Click to resend receipt
                </Button>
                { receiptSent ? <Typography style={{ paddingRight: '16px' }}>{`Resent: ${receiptSent}`}</Typography> : null }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

RefundOrder.propTypes = {
  refundOrder: PropTypes.func.isRequired,
  resendReceipt: PropTypes.func.isRequired,
  resultNum: PropTypes.number.isRequired,
  order: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    gift: PropTypes.oneOfType([null, PropTypes.string]),
    id: PropTypes.number.isRequired,
    User: PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    }).isRequired,
    Offer: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    OrderProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    OrderTransactions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    receiptSent: PropTypes.string,
    refunded: PropTypes.string,
    total: PropTypes.string.isRequired
  }).isRequired
};

const mapDispatchToProps = dispatch => ({
  logoutUser: () => {
    dispatch(userActions.logoutUser());
  },
  resendReceipt: (id) => {
    dispatch(actions.resendReceipt(id));
  },
  refundOrder: (id) => {
    dispatch(actions.refundOrder(id));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(RefundOrder);



// WEBPACK FOOTER //
// ./routes/Orders/components/RefundOrder/index.jsx